import { render, staticRenderFns } from "./SignupPassword.vue?vue&type=template&id=48b1fe1a&"
import script from "./SignupPassword.vue?vue&type=script&lang=js&"
export * from "./SignupPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports